import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AgGridDataModel, AgGridDataModelwithShortCode } from './common-ag-grid-dropdown.model';
import { AgGridI } from '../../ag-grid/ag-grid.model';
import { IconHover } from '../../../enum/common-enum';

@Component({
  selector: 'app-common-ag-grid-dropdown',
  templateUrl: './common-ag-grid-dropdown.component.html',
  styleUrls: ['./common-ag-grid-dropdown.component.scss']
})
export class CommonAgGridDropdownComponent {
  searchValue = '';
  agGridDataModel: AgGridI;
  currentHoverEffect = IconHover.Pink;
  gridApi: any;
  @Input() data: any;
  originalGridData: any[] = [];
  highlightedIndex = -1;
  constructor(public activeModal: NgbActiveModal) { }
  ngOnInit(): void {
    if (this.data?.focusedColumnId === 'productDetailId' || this.data?.focusedColumnId ==='categoryId') {
      this.agGridDataModel = AgGridDataModelwithShortCode;
    }else{
      this.agGridDataModel = AgGridDataModel;
    }
  }

  onGridReady(event) {
    this.gridApi = event;
    this.originalGridData = this.data?.gridData || [];
  
    setTimeout(() => {
      this.gridApi?.api?.setRowData(this.originalGridData);
  
      if (this.data?.currentselectedId) {
        const selectedItemIndex = this.originalGridData.findIndex(item => item.id === this.data?.currentselectedId);
        this.highlightedIndex = selectedItemIndex !== -1 ? selectedItemIndex : 0;
      } else {
        this.highlightedIndex = this.originalGridData.length > 0 ? 0 : -1;
      }

      if (this.highlightedIndex !== -1) {
        this.selectRow(this.highlightedIndex);
      }
    }, 0);
  }
  
  selectRow(index: number) {
    this.gridApi?.api?.deselectAll();
    const rowNode = this.gridApi?.api?.getDisplayedRowAtIndex(index);
    if (rowNode) {
      this.gridApi.api.ensureIndexVisible(index);
      rowNode.setSelected(true);
    }
  }
  
  onSearchChange() {
    if (this.searchValue?.trim().length >= 0) {
      const searchLower = this.searchValue?.trim()?.toLowerCase();
      const filteredData = this.originalGridData?.filter(x => x?.name?.toLowerCase()?.includes(searchLower) ||
      x?.extra3?.toLowerCase()?.includes(searchLower)) || [];
      this.gridApi?.api?.setRowData(filteredData);
      this.highlightedIndex = filteredData.length ? 0 : -1;
      if (filteredData.length) this.selectRow(this.highlightedIndex);
    } else {
      this.gridApi?.api?.setRowData(this.originalGridData);
      this.highlightedIndex = -1;
    }
  }
  

  onKeyDown(event: KeyboardEvent) {
    const rowCount = this.gridApi?.api?.getDisplayedRowCount() || 0;
    if (rowCount === 0) return;
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      if (this.highlightedIndex < rowCount - 1) {
        this.highlightedIndex++;
        this.selectRow(this.highlightedIndex);
      }
    }
    if (event.key === 'ArrowUp') {
      event.preventDefault();
      if (this.highlightedIndex > 0) {
        this.highlightedIndex--;
        this.selectRow(this.highlightedIndex);
      }
    }
    if (event.key === 'Enter') {
      event.preventDefault();
      this.confirmRowSelection();
    }
  }

  confirmRowSelection() {
    const rowNode = this.gridApi?.api?.getDisplayedRowAtIndex(this.highlightedIndex);
    this.activeModal?.close(rowNode?.data?.id ?? 0);
  }


  handleRowClicked(seletedRowData)
  {
    if (seletedRowData) {
      this.activeModal?.close(seletedRowData?.data?.id ?? 0);
    }
  }
}